const filters = (state = {}, action) => {
    switch(action.type) {
        case 'filters/clear':
            return {};
        case 'filters/update':
            return state;
        default: 
            return state;
    }
};

export default filters;